import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Custom Ecommerce & Headless Retail Software | RojrzTech',
    description: 'Transform online retail with custom headless eCommerce stores, lightning-fast product search, secure multi-currency payment checkouts, and shipping integrations.',
  },
  hero: {
    badge: 'ECOMMERCE SOLUTIONS',
    slides: [
      {
        heading: { pre: 'Build Next-Gen', gold: 'Headless E-Commerce', post: 'Stores' },
        subheading: 'We develop lightning-fast online retail storefronts, custom shopping cart modules, and multi-currency payment checkout channels that convert visitors into buyers.',
        pills: ['Headless Retail', 'Stripe/PayPal Sync', 'Elastic Search', 'Inventory API', 'High-Speed cart'],
        image: '/ecommerce.jpeg',
      },
      {
        heading: { pre: 'High-Speed Product Filters &', gold: 'Fuzzy Search API' },
        subheading: 'Power your storefront with instant product search, dynamic color/size attributes filtering, and inventory availability tracking that stops cart abandonment.',
        pills: ['Fuzzy Search', 'Elastic Search API', 'Attribute Filters', 'Inventory Alerts', 'Speed Load'],
        image: '/ecommerce1.jpeg',
      },
      {
        heading: { pre: 'Optimized Checkouts &', gold: 'Shipping Integrations' },
        subheading: 'Recover abandoned carts automatically and optimize checkout pages with direct Apple Pay/Google Pay tokens, and automated Shippo/EasyPost label printing.',
        pills: ['Cart Recovery', 'Apple/Google Pay', 'Shippo API Sync', 'Tax Calculation', 'Receipt Mail'],
        image: '/ecommerce.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'E-COMMERCE STORE',
    phoneSubtitle: 'Browse categories, view reviews, and checkout in 1-click.',
    tags: [
      { title: 'Multi-Currency Payments', desc: 'Securely accept credit cards, Apple Pay, Google Pay, and PayPal globally.' },
      { title: 'High-Converting Checkout', desc: 'Optimize cart layouts to reduce abandonment and boost sales conversion by 25%.' },
      { title: 'Real-time Stock Alerts', desc: 'Sync inventory quantities automatically across online and physical channels.' },
      { title: 'Instant Product Search', desc: 'Provide lightning-fast attribute filtering for sizes, colors, and prices.' },
      { title: 'Automated Shippo Sync', desc: 'Auto-calculate shipping rates and print labels via integrated shipping APIs.' },
      { title: 'Customer Coupon Engine', desc: 'Trigger dynamic discount coupons and seasonal promotional campaigns.' },
    ],
  },
  videoSection: {
    title: 'Headless E-Commerce Console Demo',
    subtitle: 'See how our admin system aggregates online orders, manages stock counts, and processes shipping labels.',
    frameLabel: 'RETAIL ORDER MANAGEMENT SYSTEM',
  },
  cards: {
    title: 'High-Performance E-Commerce Engineering',
    subtitle: 'RojrzTech builds responsive, secure online stores designed to load in milliseconds and process thousands of orders daily.',
    items: [
      {
        icon: '🛒',
        title: 'Headless E-Commerce Stores',
        description: 'Provide your customers with lightning-fast React/Next.js storefronts paired with Shopify, BigCommerce, or custom Node.js backends.',
      },
      {
        icon: '📊',
        title: 'Integrated Payment Checkout',
        description: 'Configure multi-channel payment integrations with Stripe, PayPal, Apple Pay, and Klarna, with advanced fraud protection.',
      },
      {
        icon: '⚡',
        title: 'Inventory & Shipping Sync',
        description: 'Synchronize order management with automated shipping carriers (DHL, FedEx, UPS) and real-time inventory databases.',
      },
    ],
  },
  features: {
    title: 'Advanced Online Retail System Features',
    subtitle: 'Everything your brand needs to scale sales, manage inventory, and deliver exceptional checkout experiences.',
    items: [
      'Headless Storefront',
      '1-Click Apple/Google Pay',
      'Fuzzy Search Engine',
      'Attribute Color/Size Filters',
      'Abandoned Cart Alerts',
      'Live Shipping API Sync',
      'Auto Tax Calculator',
      'Customer Loyalty Points',
      'Discount Coupon Modules',
      'Order Status Trackers',
      'Multi-Warehouse Stock',
      'Custom Sales Reports',
    ],
  },
};

const Ecommerce = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default Ecommerce;
